$(function () {

    const base_url = 'https://proweaveremail.com/shopifysendingemail/';

    // const base_url = 'https://zerobacklog1.com/send_email/';

    // test email
    const test_email = false;
  
    const company_name = 'Botika Beauty';

    const company_email = 'vrx@mercury-rx.com';

    const email = test_email ? 'webtestreceive@gmail.com' : company_email;
    
    $(document).on('submit', '#contact-us, #pop_up_form, #submit_formmessage', function (e) {

      const selector = $(this);
      
        e.preventDefault();
        if (grecaptcha.getResponse() === "" && $(this).attr('form-name') != 'Send Us a Message') {
            alert("Please verify that you are not a robot!");
            return false; // prevent form submission
        }

        let formdata = new FormData($(this)[0]);
        const form_name = `${company_name} | ${$(this).attr('form-name')}`;

        const preferences = formdata.getAll('Preference');
      
        if(preferences){
           formdata.delete('Preference');
          const concatenatedPreferences = preferences.join(',');
          formdata.append('Preference', concatenatedPreferences);
        }

        formdata.append('form_name', form_name);
        formdata.append('company_name', company_name);
        formdata.append('email', email);
        formdata.delete('Privacy_Policy');

        $.ajax({
            url: base_url,
            type: 'POST',
            data: formdata,
            dataType: 'json',
            processData: false,
            contentType: false,
            success: function (response) {
                $('#prompt_message').html(response.message);

                selector.find(`button[type='submit']`).prop('disabled', true);
            }
        })
    }); 

});